/* eslint-disable */
import React, { Fragment } from 'react'
import Vendor from './Vendor'

export default (props) => (
	<section id='vendor_list'>
		{props.vendors.map((vendor, idx) => {
			return (<Vendor key={idx} vendor={vendor} resultsId={props.resultsId} />)
		})}
	</section>
)


// WEBPACK FOOTER //
// ./src/containers/Results/VendorList.js